import React, { useState, useEffect, useContext } from "react";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "./../Componentes/www/style.css";
import moment from "moment";
import Select from "react-select";
import { NavLink as RRNavLink } from "react-router-dom";
import { CLOSE_IMAGE } from "../Componentes/Image";
import {PublicidadModal,ImageTooltipModalPublicidad} from './../Componentes/Modal';
import {DATATABLE_CATEGORIAS,DATATABLE_USUARIOS,DATATABLE_MARCAS,DATATABLE_BODEGAS, DATATABLE_GARANTIA,DATATABLE_DESCUENTO, DATATABLE_ARTICULO, DATATABLE_PUBLICIDAD} from "../Componentes/Datatables";
import {
  BodegaModal,
  CategoriaModal,
  MarcaModal,
  UsuariosModal,
  DeleteModal,
  GarantiaModal,
  DescuentoModal
} from "./../Componentes/Modal";
import StoreContext from "./../Componentes/Store/Context";
import {
  MDBIcon,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
  MDBRow,
  MDBCol,
  MDBInput,
  MDBBtn,
  MDBTextArea,MDBTypography
} from "mdb-react-ui-kit";

import {
  get_img_publicidad,
  put_compania,
  get_bod_bodega,
  post_bod_bodega,
  put_bod_bodega_sts,
  put_bod_bodega,
  get_cat_categoria,
  post_cat_categoria,
  put_cat_categoria,
  put_cat_categoria_sts,
  get_mar_marca,
  post_mar_marca,
  put_mar_marca,
  put_mar_marca_sts,
  get_usr_usuario,
  post_usr_usuario,
  put_usr_usuario,
  put_usr_usuario_sts,
  put_res_restaurante,
  put_res_restaurante_sts,
  post_res_restaurante,
  get_res_restaurante,
  put_gr_garantia,
  put_gr_garantia_sts,
  post_gr_garantia,
  get_gr_garantia,
  get_des_descuento,
  put_des_descuento,
  put_des_descuento_sts,
  post_des_descuento,
  imgURLocalImage,
  put_delete_img_publicidad,
  imgURLServerPublicidad,
  put_img_publicidad,
  post_img_publicidad,
  get_compania_all,
  put_bod_bodega_principal
} from "../Componentes/Services";
import { Container, Label, Row, Col, NavLink } from "reactstrap";
import { error } from "jquery";
export const Configuracion = () => {
  const [iconsActive, setIconsActive] = useState("tab2");

  const handleIconsClick = (value) => {
    if (value === iconsActive) {
      return;
    }
    setIconsActive(value);
  };
  return (
    <>
    <Container fluid className="font-s12px">
      <Row>
        <Col xs={11}>
            <MDBTabs>
            <MDBTabsItem>
              <MDBTabsLink onClick={() => handleIconsClick("tab2")} active={iconsActive === "tab2"}>
                <MDBIcon fas icon="warehouse" className="me-2" /> Bodegas
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink onClick={() => handleIconsClick("tab3")} active={iconsActive === "tab3"}>
                <MDBIcon fas icon="people-carry" className="me-2" /> Categorias
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink onClick={() => handleIconsClick("tab4")} active={iconsActive === "tab4"}>
                <MDBIcon fas icon="code-branch" className="me-2" /> Marcas
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink onClick={() => handleIconsClick("tab6")} active={iconsActive === "tab6"}>
                <MDBIcon fas icon="award" className="me-2" /> Garantías
              </MDBTabsLink>
            </MDBTabsItem>
            <MDBTabsItem>
              <MDBTabsLink onClick={() => handleIconsClick("tab7")} active={iconsActive === "tab7"}>
                <MDBIcon fas icon="cubes" className="me-2" /> Publicidad
              </MDBTabsLink>
            </MDBTabsItem>

          </MDBTabs>
        </Col>
        <Col xs={1}>
          <MDBTabs>
            <NavLink tag={RRNavLink} to="/user/home" className="font-w-bold   menu-l-c">
              <img src={CLOSE_IMAGE} className="src-image position-close" alt="..."/>
            </NavLink>
          </MDBTabs>
        </Col>
      </Row>
    </Container>
      

      <MDBTabsContent>
        <MDBTabsPane show={iconsActive === "tab2"}  className="overflow-c">
          <Bodegas />
        </MDBTabsPane>
        <MDBTabsPane show={iconsActive === "tab3"}>
          <Categorias />
        </MDBTabsPane>
        <MDBTabsPane show={iconsActive === "tab4"}>
          <Marcas />
        </MDBTabsPane>
        <MDBTabsPane show={iconsActive === "tab6"}>
          <Garantia />
        </MDBTabsPane>
        <MDBTabsPane show={iconsActive === "tab7"}>
          <Publicidad />
        </MDBTabsPane>
        <MDBTabsPane show={iconsActive === "tab8"}>
          <Restaurante />
        </MDBTabsPane>
      </MDBTabsContent>
    </>
  );
};

function Bodegas() {
  const [loading, setLoading] = useState(false);
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [error, setError] = useState("");
  const { usr_sucursal } = useContext(StoreContext);
  const [dataBodegas, setDataBodegas] = useState([]);
  const [dataCompania, setDataCompania] = useState([]);
  const [formBodegas, setFormBodegas] = useState({
    bod_id: "",
    bod_nombre: "",
    bod_suc:"",
    bod_ubicacion: "",
    bod_sts: "",
  });

  
  async function fetchCompania() {
    var response;
    response = await get_compania_all();
    setDataCompania(response);
  }

  const onClickUpdateBodega = () => {
    setLoading(true);
    var body = {
      bod_id: formBodegas.bod_id,
      bod_suc: formBodegas.bod_suc,
      bod_nombre: formBodegas.bod_nombre,
      bod_ubicacion: formBodegas.bod_ubicacion,
    };
    var result = put_bod_bodega(body);
    result.then((data) => {
      setError("");
      if(data===true){
        setLoading(false)
        fetchBodega();
      }
       
      else
        setError("ERROR "+data);
    })
  };

  const setBodegaPrincipal = (row) => {
    var body = {
      bod_id: row.bod_id,
      bod_suc:row.bod_suc
    };

    var result = put_bod_bodega_principal(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchBodega();
      else
        setError("ERROR "+data);
    })
  };
  const onClickUpdateBodega_sts = () => {
    var body = {
      bod_id: formBodegas.bod_id,
      bod_sts: 0,
    };

    var result = put_bod_bodega_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchBodega();
      else
        setError("ERROR "+data);
    })
  };

  const onClickSaveBodega = () => {
    setLoading(true)
    var body = {
      bod_suc: usr_sucursal,
      bod_nombre: formBodegas.bod_nombre,
      bod_suc:formBodegas.bod_suc,
      bod_ubicacion: formBodegas.bod_ubicacion,
    };
    if (formBodegas.bod_nombre.length > 0) {
      var result = post_bod_bodega(body);
      result.then((data) => {
        setError("");
        if(data===true){
          setLoading(false);
          fetchBodega();
        }
        
        else
          setError("ERROR "+data);
      })
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchBodega() {
    var response;
    response = await get_bod_bodega();
    setDataBodegas(response);
    setBasicModal(false);
    setBasicModalDelete(false);
    setBasicModalEdit(false)
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormBodegas({
      ...formBodegas,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchBodega();
    fetchCompania()
  }, []);

  const onChangeDropdown = (selectedOptions) => {
        setFormBodegas({
      ...formBodegas,
      bod_suc: selectedOptions.value,
    });
  };

  return (
    <Container  fluid className="font-s12px">
      {basicModal && (
        <BodegaModal
          props={formBodegas}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveBodega}
          toggleSaveEdit={onClickUpdateBodega}
          onChange={onChange}
          error={error}
          loading={loading}
          dataCompania={dataCompania}
          onChangeDropdown={onChangeDropdown}
        />
      )}
      {basicModalDelete && (
        <DeleteModal
          props={formBodegas.bod_nombre}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateBodega_sts}
          text={"Eliminar este registro?"}
          error={error}
        />
      )}
      <Row>
        <Col className="modal-add-inventario datatable-factura css_datatable1">
        <DATATABLE_BODEGAS dataBodegas={dataBodegas} setBasicModalDelete={setBasicModalDelete} setFormBodegas={setFormBodegas} 
        setBasicModal={setBasicModal} setBasicModalEdit={setBasicModalEdit} setError={setError} fetchBodega={fetchBodega} setBodegaPrincipal={setBodegaPrincipal}/>
        </Col>
      </Row>
    </Container>
  );
}
function Categorias() {
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [isLoadingCa, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [dataCategorias, setDataCategorias] = useState([]);
  const [formCategorias, setFormCategorias] = useState({
    cat_id: "",
    cat_descripcion: "",
    cat_sts: "",
  });

  const onClickUpdateCategorias = () => {
    setLoading(true)
    var body = {
      cat_id: formCategorias.cat_id,
      cat_descripcion: formCategorias.cat_descripcion,
    };

    var result = put_cat_categoria(body);
    result.then((data) => {
      setError("");
      if(data===true){
        setLoading(false);
        fetchCategoria();
      }
      
      else
        setError("ERROR "+data);
    });
  };

  const onClickUpdateCategorias_sts = () => {
    var body = {
      cat_id: formCategorias.cat_id,
      cat_sts: 0,
    };

    var result = put_cat_categoria_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchCategoria();
      else
        setError("ERROR "+data);
    });
  };

  const onClickSaveCategorias = () => {
    setLoading(true)
    var body = {
      cat_descripcion: formCategorias.cat_descripcion,
    };
    if (formCategorias.cat_descripcion.length > 0) {
      var result = post_cat_categoria(body);
      result.then((data) => {
        setError("");
        if(data===true){
          setLoading(false)
          fetchCategoria();
        }
          
        else
          setError("ERROR "+data);
      });
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchCategoria() {
    setLoading(true);
    var response;
    response = await get_cat_categoria();
    setDataCategorias(response);
    setBasicModalDelete(false);
    setBasicModalEdit(false)
    setBasicModal(false);
    setLoading(false);
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormCategorias({
      ...formCategorias,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchCategoria();
  }, []);

  return (
    <Container  fluid className="font-s12px">
      {basicModal && (
        <CategoriaModal
          props={formCategorias}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveCategorias}
          toggleSaveEdit={onClickUpdateCategorias}
          onChange={onChange}
          error={error}
          loading={isLoadingCa}
        />
      )}
      {basicModalDelete && (
        <DeleteModal
          props={formCategorias.cat_descripcion}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateCategorias_sts}
          text={"Eliminar este registro?"}
          error={error}
        />
      )}
      <Row>
        <Col className="modal-add-inventario datatable-factura css_datatable1">
        <DATATABLE_CATEGORIAS
        dataCategorias={dataCategorias} 
        setBasicModalDelete={setBasicModalDelete} 
        setFormCategorias={setFormCategorias} 
        setBasicModal={setBasicModal} setBasicModalEdit={setBasicModalEdit}
        setError={setError} fetchCategoria={fetchCategoria}isLoadingCa={isLoadingCa}
        />
        </Col>
      </Row>
    </Container>
  );
}
function Marcas() {
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [isLoadingM, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [dataMarcas, setDataMarcas] = useState([]);
  const [formMarcas, setFormMarcas] = useState({
    mar_id: "",
    mar_descripcion: "",
    mar_sts: "",
  });

  const onClickUpdateMarcas = () => {
    setLoading(true)
    var body = {
      mar_id: formMarcas.mar_id,
      mar_descripcion: formMarcas.mar_descripcion,
    };

    var result = put_mar_marca(body);
    result.then((data) => {
      setError("");
      if(data===true){
        setLoading(false)
        fetchMarcas();
      }
       
      else
        setError("ERROR "+data);
    });
  };

  const onClickUpdateMarcas_sts = () => {
    var body = {
      mar_id: formMarcas.mar_id,
      mar_sts: 0,
    };

    put_mar_marca_sts(body);
    var result = put_mar_marca_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchMarcas();
      else
        setError("ERROR "+data);
    });
  };

  const onClickSaveMarcas = () => {
    setLoading(true)
    var body = {
      mar_descripcion: formMarcas.mar_descripcion,
    };
    if (formMarcas.mar_descripcion.length > 0) {
      var result = post_mar_marca(body);
      result.then((data) => {
        setError("");
        if(data===true){
          setLoading(false)
          fetchMarcas();
        }
        
        else
          setError("ERROR "+data);
      });
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchMarcas() {
    setLoading(true);
    var response;
    response = await get_mar_marca();
    setDataMarcas(response);
    setBasicModal(false);
    setBasicModalDelete(false);
    setBasicModalEdit(false)
    setLoading(false);
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormMarcas({
      ...formMarcas,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchMarcas();
  }, []);

  return (
    <Container  fluid className="font-s12px">
      {basicModal && (
        <MarcaModal
          props={formMarcas}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveMarcas}
          toggleSaveEdit={onClickUpdateMarcas}
          onChange={onChange}
          error={error}
          loading={isLoadingM}
        />
      )}
            {basicModalDelete && (
        <DeleteModal
          props={formMarcas.mar_descripcion}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateMarcas_sts}
          text={"Eliminar este registro?"}
          error={error}
        />
      )}
      <Row>
        <Col className="modal-add-inventario datatable-factura css_datatable1">
        <DATATABLE_MARCAS dataMarcas ={dataMarcas} 
        setBasicModalDelete={setBasicModalDelete}
        setFormMarcas={setFormMarcas}
        setBasicModal={setBasicModal}
        setBasicModalEdit={setBasicModalEdit}
        setError={setError}
        fetchMarcas={fetchMarcas}
        isLoadingM={isLoadingM} />
        </Col>
      </Row>
    </Container>
  );
}
function Garantia() {
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [isLoadingG, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [dataGarantia, setDataGarantia] = useState([]);
  const [formGarantia, setFormGarantia] = useState({
    gr_id: "",
    gr_name: "",
    gr_descripcion: "",
    gr_sts:""
  });

  const onClickUpdateGarantia = () => {
    setLoading(true)
    var body = {
      gr_id: formGarantia.gr_id,
      gr_name:formGarantia.gr_name,
      gr_descripcion: formGarantia.gr_descripcion,
    };

    var result = put_gr_garantia(body);
    result.then((data) => {
      setError("");
      if(data===true){
        setLoading(false)
        fetchGarantia();
      }  
      else
        setError("ERROR "+data);
    });
  };

  const onClickUpdateGarantia_sts = () => {
    var body = {
      gr_id: formGarantia.gr_id,
      gr_sts: 0,
    };

    var result = put_gr_garantia_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchGarantia();
      else
        setError("ERROR "+data);
    });
  };

  const onClickSaveGarantia = () => {
    setLoading(true)
    var body = {
      gr_name:formGarantia.gr_name,
      gr_descripcion: formGarantia.gr_descripcion,
    };
    if (formGarantia.gr_descripcion.length > 0 && formGarantia.gr_name.length) {
      var result = post_gr_garantia(body);
      result.then((data) => {
        setError("");
        if(data===true){
          setLoading(false)
          fetchGarantia();
        }
        
        else
          setError("ERROR "+data);
      });
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchGarantia() {
    setLoading(true);
    var response;
    response = await get_gr_garantia();
    setDataGarantia(response);
    setBasicModal(false);
    setBasicModalDelete(false);
    setBasicModalEdit(false)
    setLoading(false);
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormGarantia({
      ...formGarantia,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchGarantia();
  }, []);

  return (
    <Container  fluid className="font-s12px">
      {basicModal && (
        <GarantiaModal
          props={formGarantia}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveGarantia}
          toggleSaveEdit={onClickUpdateGarantia}
          onChange={onChange}
          error={error}
          loading={isLoadingG}
        />
      )}
            {basicModalDelete && (
        <DeleteModal
          props={formGarantia.gr_name}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateGarantia_sts}
          text={"Eliminar este registro?"}
          error={error}
        />
      )}
      <Row>
        <Col className="modal-add-inventario datatable-factura css_datatable1">
        <DATATABLE_GARANTIA dataGarantia ={dataGarantia} 
        setBasicModalDelete={setBasicModalDelete}
        setFormGarantia={setFormGarantia}
        setBasicModal={setBasicModal}
        setBasicModalEdit={setBasicModalEdit}
        setError={setError}
        fetchGarantia={fetchGarantia}
        isLoadingG={isLoadingG} />
        </Col>
      </Row>
    </Container>
  );
}
function Descuento() {
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [isLoadingDes, setLoadingDes] = useState(false);
  const [error, setError] = useState("");
  const [dataDescuento, setDataDescuento] = useState([]);
  const [formDescuento, setFormDescuento] = useState({
    des_id: "",
    des_number: "",
    des_code: "",
    des_sts:""
  });

  const onClickUpdateDescuento = () => {
    setLoadingDes(true)
    var body = {
      des_id: formDescuento.des_id,
      des_number:formDescuento.des_number,
      des_code: formDescuento.des_code,
    };

    var result = put_des_descuento(body);
    result.then((data) => {
      setError("");
      if(data===true){
        setLoadingDes(false)
        fetchDescuento();
      }  
      else
        setError("ERROR "+data);
    });
  };

  const onClickUpdateDescuento_sts = () => {
    var body = {
      des_id: formDescuento.des_id,
      des_sts: 0,
    };

    var result = put_des_descuento_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchDescuento();
      else
        setError("ERROR "+data);
    });
  };

  const onClickSaveDescuento = () => {
    setLoadingDes(true)
    var body = {
      des_number:formDescuento.des_number,
      des_code: formDescuento.des_code,
    };
    if (formDescuento.des_number.length > 0 && formDescuento.des_code.length) {
      var result = post_des_descuento(body);
      result.then((data) => {
        setError("");
        if(data===true){
          setLoadingDes(false)
          fetchDescuento();
        }
        
        else
          setError("ERROR "+data);
      });
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchDescuento() {
    setLoadingDes(true);
    var response;
    response = await get_des_descuento();
    setDataDescuento(response);
    setBasicModal(false);
    setBasicModalDelete(false);
    setBasicModalEdit(false)
    setLoadingDes(false);
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormDescuento({
      ...formDescuento,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchDescuento();
  }, []);

  return (
    <Container  fluid className="font-s12px">
      {basicModal && (
        <DescuentoModal
          props={formDescuento}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveDescuento}
          toggleSaveEdit={onClickUpdateDescuento}
          onChange={onChange}
          error={error}
          loading={isLoadingDes}
        />
      )}
      {basicModalDelete && (
        <DeleteModal
          props={formDescuento.des_code}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateDescuento_sts}
          text={"Eliminar este registro?"}
          error={error}
        />
      )}
      <Row>
        <Col className="modal-add-inventario datatable-factura css_datatable1">
        <DATATABLE_DESCUENTO dataDescuento ={dataDescuento} 
        setBasicModalDelete={setBasicModalDelete}
        setFormDescuento={setFormDescuento}
        setBasicModal={setBasicModal}
        setBasicModalEdit={setBasicModalEdit}
        setError={setError}
        fetchDescuento={fetchDescuento}
        isLoadingDes={isLoadingDes}
        setLoadingDes={setLoadingDes}
         />
     
        </Col>
      </Row>
    </Container>
  );
}
function Publicidad() {
  const [srcImage, setSrcImage] = useState("");
  const [basicModalImageTooltip, setModalImageTooltip] = useState(false);
  const [images, setImages] = React.useState([]);
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [isLoadingPublicidad, setLoadingPublicidad] = useState(false);
  const [error, setError] = useState("");
  const [dataPublicidad, setDataPublicidad] = useState([]);
  const [formPublicidad, setFormPublicidad] = useState({
    img_id: "",
    img_name: "",
    img_sts:"",
    img_dataurl:"",
    img_type:""
  });

  async function fetchPublicidad() {
    setLoadingPublicidad(true);
    var response;
    response = await get_img_publicidad();
    setDataPublicidad(response);
    setLoadingPublicidad(false);
    setError("");
    setBasicModal(false)
  }


    const removeImage = (data) => {
        var body = {
          img_id: data.img_id,
        };
  
        var result = put_delete_img_publicidad(body);
        result.then((data) => {
          setError("");
          if(data===true){
            setFormPublicidad({
              ...formPublicidad,
              img_id: "",
              img_name: "",
              img_sts:"",
              img_dataurl:"",
              img_type:""
            });
            fetchPublicidad()
            }
          else
            setError("ERROR "+data);
        });
  
    };
  const onChangeImage = (imageList) => {
    setFormPublicidad({
      ...formPublicidad,
      img_dataurl: imageList[0]===undefined?"":imageList[0].data_url,
      img_type: imageList[0]===undefined?"":imageList[0].file.type,
    });
    setImages(imageList);
  };
  useEffect(() => {
    fetchPublicidad();
  }, []);

  const toggleSave = () => {
    var body = {
      img_id : formPublicidad.img_id ,
      img_dataurl: formPublicidad.img_dataurl,
      img_type: formPublicidad.img_type !== undefined ? formPublicidad.img_type : "none",
      img_URLServer: imgURLServerPublicidad,
      img_name:formPublicidad.img_dataurl !== undefined? moment(new Date()).format("YYYYMMDDHHmmss"): formPublicidad.img_name,
    };
    if (formPublicidad.img_dataurl.length > 0 &&
      formPublicidad.img_type.length > 0) {
        var result = post_img_publicidad(body);
        result.then((data) => {
          setError("");
          if(data===true)
          {
            setLoadingPublicidad(false)
            fetchPublicidad();
          }
            
          else
            setError("ERROR "+data);
        });
      }
  }

  return (
    <Container  fluid className="font-s12px">
      {basicModalImageTooltip && (
      <ImageTooltipModalPublicidad
        isOpen={basicModalImageTooltip}
        toggle={setModalImageTooltip}
        srcImage ={srcImage}
        ImgName ={srcImage}
      />
      )}
      {basicModal && (
        <PublicidadModal
          toggle={setBasicModal}
          isOpen={basicModal}
          props={formPublicidad}
          onChangeImage={onChangeImage}
          images={images}
          removeImage={removeImage}
          basicModalEdit={basicModalEdit}
          toggleSave={toggleSave}
          loading={isLoadingPublicidad}
          error={error}
        />
      )}
      <Row>
        <Col xs ={12} className="modal-add-inventario datatable-factura css_datatable1">
          <DATATABLE_PUBLICIDAD datapublicidad = {dataPublicidad} setFormPublicidad = {setFormPublicidad} removeImage={removeImage}
          fetchPublicidad={fetchPublicidad} setBasicModal={setBasicModal} setImages={setImages} setSrcImage= {setSrcImage} setModalImageTooltip ={setModalImageTooltip}/>
        </Col>
      </Row>
    </Container>
  );
}
function Restaurante() {
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalDelete, setBasicModalDelete] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [isLoadingRes, setLoadingRes] = useState(false);
  const [error, setError] = useState("");
  const [dataRestaurante, setDataRestaurante] = useState([]);
  const [formRestaurante, setFormRestaurante] = useState({
    res_id: "",
    res_nombre: "",
    res_sts: ""
  });

  const onClickUpdateRestaurante = () => {
    var body ={
      res_nombre:formRestaurante.res_nombre
    }
    var result = put_res_restaurante(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchRestaurante();
      else
        setError("ERROR "+data);
    });
  };

  const onClickUpdateRestaurante_sts = () => {
    var body = {
      res_id: formRestaurante.res_id,
      res_sts: 0,
    };
    var result = put_res_restaurante_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchRestaurante();
      else
        setError("ERROR "+data);
    });
  };

  const onClickSaveUsuarios = () => {
    if (formRestaurante.res_nombre.length > 0 ) {
      var result = post_res_restaurante(formRestaurante);
      result.then((data) => {
        setError("");
        if(data===true)
          fetchRestaurante();
        else
          setError("ERROR "+data);
      });
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchRestaurante() {
    setLoadingRes(true);
    var response;
    response = await get_res_restaurante();
    setDataRestaurante(response);
    setBasicModal(false);
    setBasicModalDelete(false);
    setBasicModalEdit(false)
    setLoadingRes(false);
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormRestaurante({
      ...formRestaurante,
      [name]: value,
    });
    setError("");
  }

  useEffect(() => {
    fetchRestaurante();
  }, []);

  const onChangeDropdown = () => {
    setFormRestaurante({
      ...formRestaurante,
      // usr_perfil:selectedOptions.value
  })
    // if(selectedOptions.objName==="print"){
    //   setFormUsuarios({
    //     ...formRestaurante,
    //     usr_print:selectedOptions.value
    // })
    // }
    // else{
    //   setFormRestaurante({
    //     ...formRestaurante,
    //     usr_perfil:selectedOptions.value
    // })
    // }
    };

    // const handleOnChangeCheckBox = (event) => {
    //   const { value, name } = event.target;
    //   setFormUsuarios({
    //     ...formUsuarios,
    //     [name]:value==="0"?"1":"0"
    // })
    // };
  return (
    <Container  fluid className="font-s12px">
      {/* {basicModal && (
        <UsuariosModal
          props={formUsuarios}
          isOpen={basicModal}
          basicModalEdit={basicModalEdit}
          toggle={setBasicModal}
          toggleSave={onClickSaveUsuarios}
          toggleSaveEdit={onClickUpdateUsuarios}
          onChange={onChange}
          error={error}
          onChangeDropdown={onChangeDropdown}
          handleOnChangeCheckBox={handleOnChangeCheckBox}
        />
      )} */}
      {basicModalDelete && (
        <DeleteModal
          props={formRestaurante.res_nombre}
          isOpen={basicModalDelete}
          toggle={setBasicModalDelete}
          toggleDelete={onClickUpdateRestaurante_sts}
          text={"Eliminar este registro?"}
          error={error}
        />
      )}
      <Row>
      <Col xs={2}>
        <form>
          <MDBInput
            id="res_nombre"
            wrapperClass="mb-4"
            type="number"
            min={1}
            max={99}
            label="* Nombre"
            name="res_nombre"
            onChange={onChange}
            defaultValue={formRestaurante.res_nombre}
          />
        </form>

        </Col>
        <Col xs={10}>
        </Col>
        <Col xs={12} className="text-center">
          <Label className="error-label">{error.length > 0 ? error : ""}</Label>
          <MDBBtn   onClick={() => onClickUpdateRestaurante()}>
          <MDBIcon fas icon="save" className="me-1" />   Guardar
          </MDBBtn>
        </Col>
      </Row>
    </Container>
  );
}